/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import CardDetails from "./CardDetails.container";

export default CardDetails;
